export default [
  {
    _name: 'CSidebarNavTitle',
    _children: ['Khách hàng v2']
  },

  { 
    _name: 'CSidebarNavItem',
    name: 'Dữ liệu',
    to: '/v2/clients',
    icon: 'cil-layers',
    permission: 'client_view'
  },

  { 
    _name: 'CSidebarNavItem',
    name: 'Nhập liệu',
    to: '/v2/clients/new',
    icon: 'cil-layers',
    permission: 'client_input'
  },
];
